import styled from "styled-components"
import { TABLET_MAX_WIDTH, MOBILE_MIN_WIDTH } from "@constants"

export const StyledArticleInformationWrapper = styled.div`
  border-top: 1px solid rgba(196, 177, 128, 0.6);
`

export const StyledAuthorInformationWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
  margin-top: 32px;

  @media only screen and (max-width: ${MOBILE_MIN_WIDTH}px) {
    flex-direction: column;
    align-items: flex-start;
  }
`

export const StyledAuthorInformationContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`

export const StyledAuthorImageContainer = styled.div``

export const StyledAuthorImage = styled.img`
  border-radius: 50%;
  height: 64px;
  width: 64px !important;
  object-fit: cover;
`

export const StyledAuthorDetailsContainer = styled.div``

export const StyledAuthorName = styled.p`
  padding: 0;
  margin: 0;
  color: rgba(37, 37, 37, 0.8);
  font-size: 20px;
  font-weight: 700;
  line-height: 150%;
  letter-spacing: 0.4px;
`
export const StyledAuthorRole = styled.div`
  padding: 0;
  margin: 0;
  color: rgba(37, 37, 37, 0.6);
  font-size: 13px;
  font-weight: 400;
  line-height: 153.846%;
  letter-spacing: 0.26px;
`
export const StyledAboutAuthor = styled.div`
  color: #252525;
  font-size: 20px;
  letter-spacing: 0.4px;
  margin-top: 30px;

  @media only screen and (max-width: ${TABLET_MAX_WIDTH}px) {
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0.8px;
  }
`

export const StyledArticleHugeLikeButtonContainer = styled.div`
  margin-top: 30px;
`


